import React from 'react'
import { withRouter, Link } from 'react-router';
import { checkPermission, getLocalStorageInfo } from '../../utils_v2';
import { jetStreamInstance, smbcInstance, testLessor } from '../../../shared/components';

function ConfigSideNav() {
    return (
        <div className='tech-specs-nav'>
            {
                checkPermission('console', 'lessor_configuration', 'R') ?
                    <div className='tech-nav-link'>
                        <Link activeClassName='active' to={`/configure`}>{jetStreamInstance ? "Lessor/Holdco" : "Lessor"} Config</Link>
                    </div>
                    : null}
            {
                checkPermission('console', 'introduction', 'R') ?
                    <div className='tech-nav-link'>
                        <Link activeClassName='active' to={`/configure/introduction`}>Introduction</Link>
                    </div>
                    : null}
            {
                checkPermission('console', '3rd_party_integration', 'R') ?
                    <div className='tech-nav-link'>
                        <Link activeClassName='active' to={`/configure/third-party-integration`}>Third Party Integration</Link>
                    </div> : null}
                    <div className='tech-nav-link'>
                        <Link activeClassName='active' to={`/configure/currencies`}>Currencies</Link>
                    </div>
            {
                smbcInstance ?
                    <div className='tech-nav-link'>
                        <Link activeClassName='active' to={`/configure/asset-manager`}>Asset Manager</Link>
                    </div> : null}
        </div>
    )
}
export default withRouter(ConfigSideNav)